"use strict";

exports.__esModule = true;
exports.ie10Plus = void 0;
var ie10Plus = '@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)';
exports.ie10Plus = ie10Plus;